import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DossierService } from "../../core/service/dossier.service";
import { Dossier } from "../../core/model/dossier";

@Component({
  selector: "app-detail-dossier-tab",
  templateUrl: "./detail-dossier-tab.component.html",
  styleUrls: ["./detail-dossier-tab.component.scss"],
})
export class DetailDossierTabComponent {
  numDossier: number;
  dossier: Dossier;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private _dossierService: DossierService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.numDossier = params["numDossier"];
      this.getDossierByNumDossier(this.numDossier);
    });
  }

  getDossierByNumDossier(numDossier) {
    this._dossierService.getDossierByNumDossier(numDossier).subscribe(
      (data) => {
        this.dossier = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
